var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPriceAlt = function SvgPriceAlt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 -2 20 20",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M14.615 0c.741 0 1.314.539 1.379 1.255l.006.136V4h2.615c.741 0 1.314.539 1.379 1.255l.006.136v8.218c0 .783-.598 1.391-1.385 1.391h-5.788a3.026 3.026 0 0 1-2.847 2 2.973 2.973 0 0 1-2.812-2H5.385A1.365 1.365 0 0 1 4 13.609l.001-2.658a.994.994 0 0 1-.192.042L3.692 11H1.385C.644 11 .07 10.461.006 9.745L0 9.609V1.39C0 .654.53.072 1.248.006L1.385 0h13.23ZM18 6H6v7h1.168c.407-1.169 1.51-2 2.812-2 1.315 0 2.432.84 2.847 2H18V6Zm-4-4H2v7h1.692a1 1 0 0 1 .31.049L4 5.39C4 4.608 4.598 4 5.385 4H14V2Z"
  })));
};
export default SvgPriceAlt;